// extracted by mini-css-extract-plugin
module.exports = {"imageAndMobCta":"_3TBiKmiL","cardImage":"_3s4jIqxu","ctaMob":"GkWYdSnW","customFont":"_3T79R8WG"};